import { render, staticRenderFns } from "./danCiSuJi.vue?vue&type=template&id=c7bbf0c8&scoped=true&"
import script from "./danCiSuJi.vue?vue&type=script&lang=js&"
export * from "./danCiSuJi.vue?vue&type=script&lang=js&"
import style0 from "./danCiSuJi.vue?vue&type=style&index=0&id=c7bbf0c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7bbf0c8",
  null
  
)

export default component.exports